import { useSyncExternalStore } from "react";
import { onPrefs, pushPref } from "@/lib/prefsSync";

/* Read-along text appearance (size + typeface); synced to the account like the other preferences. */
const KEY = "rh.readalong";
export const SIZES = ["sm", "md", "lg", "xl"];
export const DEFAULT = { size: "md", font: "serif", source: "book" };
let state = DEFAULT;
try { state = { ...DEFAULT, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { state = DEFAULT; }
const subs = new Set();
const emit = () => subs.forEach((fn) => fn());
const persist = (push) => { localStorage.setItem(KEY, JSON.stringify(state)); emit(); if (push) pushPref("readalong", state); };

onPrefs("readalong", {
  apply: (v) => { state = { ...DEFAULT, ...(v || {}) }; persist(false); },
  read: () => state,
});

export const useReadAlongPrefs = () => useSyncExternalStore((fn) => { subs.add(fn); return () => subs.delete(fn); }, () => state);
export const setReadAlongPref = (patch) => { state = { ...state, ...patch }; persist(true); };
export const stepSize = (dir) => {
  const i = Math.max(0, Math.min(SIZES.length - 1, SIZES.indexOf(state.size) + dir));
  setReadAlongPref({ size: SIZES[i] });
};
export const SIZE_CLASS = {
  sm: "text-base leading-relaxed sm:text-lg sm:leading-relaxed",
  md: "text-xl leading-relaxed sm:text-2xl sm:leading-relaxed",
  lg: "text-2xl leading-relaxed sm:text-3xl sm:leading-relaxed",
  xl: "text-3xl leading-relaxed sm:text-4xl sm:leading-relaxed",
};
